import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { AttachmentFolderPickerClientProviderType } from '../store/schema/AttachmentFolderPickerProviderType';
import {
    AttachmentFolderPickerProviderViewState,
    AttachmentFolderPickerGroupProviderViewState,
    AttachmentFolderPickerOneDriveProProviderViewState,
} from '../store/schema/AttachmentFolderPickerProviderViewState';

export function isGroupProviderViewState(
    viewState: AttachmentFolderPickerProviderViewState
): viewState is AttachmentFolderPickerGroupProviderViewState {
    return viewState && viewState.type === AttachmentFolderPickerClientProviderType.Group;
}

export function isOneDriveProViewState(
    viewState: AttachmentFolderPickerProviderViewState
): viewState is AttachmentFolderPickerOneDriveProProviderViewState {
    return viewState && viewState.type === AttachmentDataProviderType.OneDrivePro;
}
